import niceTry from 'nice-try'
import versionToMatch from '../version-to-match'

const version = niceTry(
  () => JSON.parse(localStorage.getItem(`version`))
)

if (version !== versionToMatch) {
  localStorage.setItem(
    `version`,
    JSON.stringify(versionToMatch)
  )
  if ('caches' in window){
    caches.keys().then(names => {
      names.forEach(async name => {
        await caches.delete(name)
      })
    })
  }
  location.reload()
}

// define a new console
if (window.ReactNativeWebView) {
  const console = (function () {
    return {
      log: function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            name: `log`,
            params: arguments
          })
        )
      },
      error: function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            name: `error`,
            params: arguments
          })
        )
      },
      warn: function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            name: `warn`,
            params: arguments
          })
        )
      },
      info: function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            name: `info`,
            params: arguments
          })
        )
      }
    }
  }(window.console))
  //Then redefine the old console
  window.console = console
}

import './backend/'
import { start, theme } from '@iez/core'
import * as features from './features/'
import * as pages from './pages/'
import priorities from './priorities/'
/* import resetSeed from './seed/'
resetSeed() */
//import Chroma from 'chroma-js'

// theme.primary.color = '#4bd973' // #4bd989 // #4bd9a5
theme.primary.color = '#4bd9a5'
/* const rotate = () => {
  theme.primary.color = Chroma(theme.primary.color).set('hsl.h', Math.random() * 255).hex()
}
 */
// rotate()

start({
  pages,
  features,
  priorities
})
